













































import OSS from "ali-oss";
import { getOSSConfig } from "@/api/ossImageUploader";
import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() originName!: string;
  @Prop() originUrl!: string;
  @Prop({ type: String, default: ".jpeg,.jpg,.png,.gif" }) accept!: string;
  @Prop({ type: Number, default: 2 }) sizeLimit!: number; //默认为2
  @Prop({ type: String, default: "image" }) mode!: string; // mode默认为image，为图片模式，鼠标上移有交互；button时是按钮模式。
  @Prop() showTransferVoucherText!: boolean;
  client = null;
  prefix = "";
  cdn_url = "";
  callback = {};
  chooseImg(e: any) {
    const self = this as any;
    getOSSConfig().then((res: any) => {
      // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
      // 不同上传请求则需要每次重新获取token
      if (res.error_code == 0) {
        self.prefix = res.data.object_name_prefix;
        self.cdn_url = res.data.cdn_url;
        self.callback = res.data.callback;
        self.client = new OSS({
          accessKeyId: res.data.access_key_id,
          accessKeySecret: res.data.access_key_secret,
          stsToken: res.data.security_token,
          region: "oss-cn-shenzhen",
          bucket: res.data.bucket,
        });
        self.client
          .put(self.prefix + e.file.name, e.file, {
            callback: {
              url: self.callback.callback_url,
              host: self.callback.callback_host,
              body: self.callback.callback_body,
              contentType: self.callback.callback_body_type,
            },
          })
          .then(function (result: any) {
            if (result.data.code == "Ok") {
              self.$emit("update:originName", result.data.object);
              self.$emit(
                "update:originUrl",
                self.cdn_url + "/" + result.data.object
              );
              self.$emit("change", {
                name: result.data.object,
                url: self.cdn_url + "/" + result.data.object,
              });
              self.$message({
                type: "success",
                message: "上传成功!",
              });
            }
          })
          .catch(function (err: any) {});
      }
    });
  }
  beforeAvatarUpload(file: any) {
    const typeArr: string[] = this.accept.split(",");
    const typePass: string[] = typeArr.filter((item: string) => {
      return file.name.indexOf(item) >= 0;
    });
    if (typePass.length === 0) {
      this.$message.error(`图片类型有误`);
      return false;
    }
    const max = this.sizeLimit;
    const pass = file.size / 1024 / 1024 < max;
    if (!pass) {
      this.$message.error(`上传图片大小不能超过${max}MB!`);
    }
    return pass;
  }
  handleClear() {
    this.$emit("update:originName", "");
    this.$emit("update:originUrl", "");
    // 处理存在多个 imageUploader 时触发
    this.$emit("clear");
  }
  handlePreviewImage() {
    const elImage: any = document.querySelector("#elImage");
    console.log(elImage);
    if (elImage) {
      elImage.click();
    }
  }
}
